import React from 'react';

export const More = ({ width = 20, height = 20, className, style }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      style={style}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.25" cy="10.25" r="1.25" fill="currentColor" />
      <circle cx="10.25" cy="10.25" r="1.25" fill="currentColor" />
      <circle cx="15.25" cy="10.25" r="1.25" fill="currentColor" />
    </svg>
  );
};
